import { Client, NewClient, ClientContact, NewContact } from '../../types';
import api from '../api';

export class ClientsService {
  static async getClients(token?: string): Promise<Client[]> {
    const response = await api.get<{ clients: Client[] }>('/api/clients', token);
    return response.clients || [];
  }

  static async createClient(clientData: NewClient, token?: string): Promise<Client> {
    const backendData = {
      company_name: clientData.name,
      contact_email: clientData.email,
      contact_phone: clientData.phone,
      address: clientData.address,
      website: clientData.website,
      industry: clientData.industry,
      company_size: clientData.companySize,
      annual_revenue: clientData.annualRevenue,
      timezone: clientData.timezone,
      status: clientData.status === 'prospective' ? 'prospect' : clientData.status,
      logo_url: clientData.logoUrl
    };
    
    return await api.post<Client>('/api/clients', backendData, token);
  }

  static async updateClient(id: number, clientData: Partial<NewClient>, token?: string): Promise<Client> {
    const backendData = {
      company_name: clientData.name,
      contact_email: clientData.email,
      contact_phone: clientData.phone,
      address: clientData.address,
      website: clientData.website,
      industry: clientData.industry,
      company_size: clientData.companySize,
      annual_revenue: clientData.annualRevenue,
      timezone: clientData.timezone,
      status: clientData.status === 'prospective' ? 'prospect' : clientData.status,
      logo_url: clientData.logoUrl
    };
    
    return await api.put<Client>(`/api/clients/${id}`, backendData, token);
  }

  static async deleteClient(id: number, token?: string): Promise<void> {
    await api.delete(`/api/clients/${id}`, token);
  }

  // Contact methods
  static async getClientContacts(clientId: number, token?: string): Promise<ClientContact[]> {
    const response = await api.get<{ contacts: ClientContact[] }>(`/api/clients/${clientId}/contacts`, token);
    return response.contacts || [];
  }

  static async createContact(clientId: number, contactData: NewContact, token?: string): Promise<ClientContact> {
    const backendData = {
      first_name: contactData.firstName,
      last_name: contactData.lastName,
      email: contactData.email,
      phone: contactData.phone,
      position: contactData.position,
      department: contactData.department,
      is_primary: contactData.isPrimary,
      is_billing: contactData.isBilling,
      notes: contactData.notes
    };
    
    return await api.post<ClientContact>(`/api/clients/${clientId}/contacts`, backendData, token);
  }
}